export { default } from './DeleteWorkspace';
